export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.c4a0f42e.svg";